import { render, staticRenderFns } from "./VisualizaOrdensDeServicos.vue?vue&type=template&id=01458be0&scoped=true&"
import script from "./VisualizaOrdensDeServicos.vue?vue&type=script&lang=js&"
export * from "./VisualizaOrdensDeServicos.vue?vue&type=script&lang=js&"
import style0 from "./VisualizaOrdensDeServicos.vue?vue&type=style&index=0&id=01458be0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01458be0",
  null
  
)

export default component.exports